module.exports = __webpack_public_path__ + "img/qilin-stage7-blink.2f8bd191.png";